const DOCUMENT_ITEM_CLASS = 'document-item';
const DOCUMENT_ITEM_WRAPPER_CLASS = 'document-item-wrapper';
const ACTION_TYPES = {
  dropdown: 'dropdown',
  download: 'download',
  redirect: 'redirect',
};
const ACTION_ICONS_MAP = {
  [ACTION_TYPES.dropdown]: 'arrow5_step',
  [ACTION_TYPES.download]: 'action_download_stroke',
  [ACTION_TYPES.redirect]: 'body_eye',
};

export { ACTION_TYPES as A, DOCUMENT_ITEM_CLASS as D, DOCUMENT_ITEM_WRAPPER_CLASS as a, ACTION_ICONS_MAP as b };
